package one.healthium.uscreen.domain.models

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class UScreenChoiceOption(
    @SerialName("key") val key: String,
    @SerialName("text") val text: GenderText,
    @SerialName("emoji") val emoji: GenderText? = null,
    @SerialName("altText") val altText: String? = null,
) {
    companion object {
        val preview = UScreenChoiceOption(
            key = "lose_weight",
            text = GenderText("Lose weight"),
            emoji = GenderText("\uD83D\uDD25"),
            altText = "weight loss",
        )
    }
}
